import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var BagIcon = function BagIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: width,
    height: height,
    fill: fill
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8H4.8a.79.79 0 00-.8.778v12.444c0 .43.358.778.8.778h14.4a.79.79 0 00.8-.778V8.778A.79.79 0 0019.2 8H17V6.667C17 4.089 14.761 2 12 2S7 4.09 7 6.667V8zm1.667 0h6.666V6.667c0-1.719-1.492-3.111-3.333-3.111-1.84 0-3.333 1.392-3.333 3.11V8zM5.6 9.556v10.888h12.8V9.556H5.6z"
  }));
};

BagIcon.displayName = 'BagIcon';
export default BagIcon;